import { useLocation } from "react-router-dom";

export const useIsGroupPage = (): boolean => {
  const location = useLocation();
  return location.pathname.includes("/g/");
};
